import { render } from "./PersonFilterSidebarHeader.vue?vue&type=template&id=0149d816&scoped=true&ts=true"
import script from "./PersonFilterSidebarHeader.vue?vue&type=script&lang=ts"
export * from "./PersonFilterSidebarHeader.vue?vue&type=script&lang=ts"

import "./PersonFilterSidebarHeader.vue?vue&type=style&index=0&id=0149d816&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0149d816"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSpace,QTooltip});
